"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CDAMainViewer = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _framerMotion = require("framer-motion");

var _queryString = _interopRequireDefault(require("query-string"));

var _components = require("../../components");

var _container = require("../../container");

var _layout = _interopRequireDefault(require("../../layout"));

var _DocumentProvider = require("../../context/DocumentProvider");

var _helper = require("../../lib/utils/helper");

var _highlighter = require("./highlighter");

var _PdfFileViewer = _interopRequireDefault(require("../PDFViewer/PdfFileViewer"));

var _BodySection = _interopRequireDefault(require("./BodySection"));

var _Global = _interopRequireDefault(require("../../styles/Global.style"));

var CDAMainViewer = function CDAMainViewer(_ref) {
  var _queryString$parse;

  var ehrRecord = _ref.ehrRecord,
      requestPatientRecord = _ref.requestPatientRecord,
      isNewRecordAvailable = _ref.isNewRecordAvailable,
      exportCDAAsPDF = _ref.exportCDAAsPDF,
      exportCDAAsPDFLoading = _ref.exportCDAAsPDFLoading,
      setExportCDAAsPDFLoading = _ref.setExportCDAAsPDFLoading;
  var navigate = (0, _reactRouterDom.useNavigate)();

  var _useSearchParams = (0, _reactRouterDom.useSearchParams)(),
      _useSearchParams2 = (0, _slicedToArray2.default)(_useSearchParams, 2),
      searchParams = _useSearchParams2[0],
      setSearchParams = _useSearchParams2[1];

  var cdaUrl = (_queryString$parse = _queryString.default.parse(searchParams.toString())) === null || _queryString$parse === void 0 ? void 0 : _queryString$parse.cdaUrl;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      rowsToExport = _useState2[0],
      setRowsToExport = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      fileName = _useState4[0],
      setFileName = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      resetRows = _useState6[0],
      setResetRows = _useState6[1];

  var _useContext = (0, _react.useContext)(_DocumentProvider.DocumentContext),
      currentDocument = _useContext.currentDocument,
      rawDocument = _useContext.rawDocument;

  var params = _queryString.default.parse(searchParams.toString() || '');

  var getRowsToHighlight = function getRowsToHighlight(searchDataGroupedByCategory, searchText) {
    return (0, _highlighter.getTextToHighlight)(searchDataGroupedByCategory, searchText);
  };

  var mainHighlighter = function mainHighlighter() {
    var filteredData = {};
    var found = false;
    var searchDataToUse = currentDocument.searchData;

    if (params.section) {
      var normalizedSection = params.section.toLowerCase().trim();
      searchDataToUse = currentDocument.searchData.filter(function (suggestion) {
        var _suggestion$groupTitl;

        return ((_suggestion$groupTitl = suggestion.groupTitle) === null || _suggestion$groupTitl === void 0 ? void 0 : _suggestion$groupTitl.toLowerCase().trim()) === normalizedSection;
      });

      if (!searchDataToUse.length) {
        searchDataToUse = currentDocument.searchData;
      }
    }

    searchDataToUse.forEach(function (suggestion) {
      var _filteredData$suggest;

      filteredData[suggestion.groupTitle] = [];
      var sortData = suggestion.data.filter(function (i) {
        if (i && i.text) {
          var normalizedData = (0, _helper.normalizeString)(i.text);
          var normalizedInput = (0, _helper.normalizeString)(params.q);
          var startCondition = normalizedData.startsWith(normalizedInput);
          var includeCondition = normalizedData.includes(normalizedInput);

          if (startCondition) {
            return startCondition;
          } else if (!startCondition && includeCondition) {
            return includeCondition;
          } else {
            return null;
          }
        }

        return null;
      }).slice(0, 1);

      (_filteredData$suggest = filteredData[suggestion.groupTitle]).push.apply(_filteredData$suggest, (0, _toConsumableArray2.default)(sortData));
    });
    found = Object.keys(filteredData).some(function (category) {
      if (filteredData[category] && filteredData[category][0]) {
        var type = filteredData[category][0].type;
        var section = filteredData[category][0].section;
        var text = filteredData[category][0].text;
        var rowId = filteredData[category][0].rowId;
        var currentParams = {};

        var _iterator = (0, _createForOfIteratorHelper2.default)(searchParams.entries()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var entry = _step.value;
            currentParams[entry[0]] = entry[1];
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var newParams = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, currentParams), {}, {
          q: ''
        });

        if (type === 'table' && rowId) {
          newParams.rowId = rowId;
          newParams.search = params.q;
        }

        if (type === 'text' && rowId && text) {
          newParams.rowId = rowId;
          newParams.search = params.q;
        }

        console.log('newParams: ', newParams);
        setSearchParams(newParams);
        return true;
      } else {
        return false;
      }
    });
    return found;
  };

  (0, _react.useEffect)(function () {
    if (params.rowId) {
      (0, _helper.priorityScrollTo)(params.rowId, 3);
    } else if (params.rowIds) {
      var rowIds = (0, _helper.tryParseJson)(params.rowIds);

      if (rowIds !== null && rowIds !== void 0 && rowIds.length) {
        (0, _helper.priorityScrollTo)(rowIds[0], 3);
      }
    } else if (params.section) {
      (0, _helper.priorityScrollTo)(params.section, 3, {
        offset: 0
      });
    }

    if (params.q && currentDocument) {
      var foundHighlight = mainHighlighter();
      console.log('foundHighlight: ', foundHighlight);

      if (!foundHighlight) {
        var _textToHighlight, _textToHighlight2;

        console.log('fallback highlight');
        var searchDataGroupedByCategory = {};
        var searchDataToUse = currentDocument.searchData;

        if (params.section) {
          var normalizedSection = params.section.toLowerCase().trim();
          searchDataToUse = currentDocument.searchData.filter(function (suggestion) {
            var _suggestion$groupTitl2;

            return ((_suggestion$groupTitl2 = suggestion.groupTitle) === null || _suggestion$groupTitl2 === void 0 ? void 0 : _suggestion$groupTitl2.toLowerCase().trim()) === normalizedSection;
          });

          if (!searchDataToUse.length) {
            searchDataToUse = currentDocument.searchData;
          }
        }

        searchDataToUse.forEach(function (item) {
          searchDataGroupedByCategory[item.groupTitle] = item.data;
        });
        var textToHighlight = getRowsToHighlight(searchDataGroupedByCategory, params.q);

        if (!((_textToHighlight = textToHighlight) !== null && _textToHighlight !== void 0 && _textToHighlight.length)) {
          searchDataGroupedByCategory = {};
          currentDocument.searchData.forEach(function (item) {
            searchDataGroupedByCategory[item.groupTitle] = item.data;
          });
          textToHighlight = getRowsToHighlight(searchDataGroupedByCategory, params.q);
        }

        if ((_textToHighlight2 = textToHighlight) !== null && _textToHighlight2 !== void 0 && _textToHighlight2.length) {
          console.log('textToHighlight: ', textToHighlight);
          var newSearchParams = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, Object.fromEntries(searchParams)), {}, {
            q: '',
            rowIds: JSON.stringify(textToHighlight),
            search: params.q
          });
          if (cdaUrl) newSearchParams.cdaUrl = cdaUrl;
          setSearchParams(newSearchParams);
        }
      }
    }
  }, [currentDocument, searchParams]);

  if (params.pdfUrl) {
    return /*#__PURE__*/_react.default.createElement(_PdfFileViewer.default, {
      pdfUrl: params.pdfUrl,
      fileName: params.fileName,
      previewPage: params.previewPage,
      boundingBox: params !== null && params !== void 0 && params.boundingBox ? JSON.parse(params === null || params === void 0 ? void 0 : params.boundingBox) : null,
      imageDimension: params !== null && params !== void 0 && params.imageDimension ? JSON.parse(params.imageDimension) : null,
      searchText: params.searchText,
      metaDataPreview: JSON.parse(params.metaDataPreview),
      metaDataDebug: JSON.parse(params.metaDataDebug)
    });
  }

  if (!currentDocument) {
    return /*#__PURE__*/_react.default.createElement(_container.FileUpload, {
      ehrRecord: ehrRecord,
      setFileName: setFileName
    });
  }

  var header = currentDocument.header,
      body = currentDocument.body;

  var resetRowsSelection = function resetRowsSelection() {
    setRowsToExport([]);
    navigate({
      search: ''
    }, {
      replace: true
    });
    setResetRows(true);
    setTimeout(function () {
      setResetRows(false);
    }, 500);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Global.default, null), /*#__PURE__*/_react.default.createElement(_framerMotion.motion.div, null, /*#__PURE__*/_react.default.createElement(_layout.default, {
    currentDocument: currentDocument,
    requestPatientRecord: requestPatientRecord,
    isNewRecordAvailable: isNewRecordAvailable,
    rowsToExport: rowsToExport,
    resetRowsSelection: resetRowsSelection,
    rawDocument: rawDocument,
    ehrRecord: ehrRecord,
    fileName: fileName,
    exportCDAAsPDF: exportCDAAsPDF,
    exportCDAAsPDFLoading: exportCDAAsPDFLoading,
    setExportCDAAsPDFLoading: setExportCDAAsPDFLoading,
    documentTitle: params.title
  }, /*#__PURE__*/_react.default.createElement(_components.DocumentHeader, {
    documentHeaderData: header
  }), body && body.map(function (section, i) {
    return /*#__PURE__*/_react.default.createElement(_BodySection.default, {
      key: i,
      section: section,
      setRowsToExport: setRowsToExport,
      resetRows: resetRows,
      currentDocument: currentDocument,
      rawDocument: rawDocument
    });
  }))));
};

exports.CDAMainViewer = CDAMainViewer;